import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContactIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			id: "Group 631652",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M89.138 26.1623C69.7025 44.467 64.4611 58.2684 48.813 66.5333C38.863 71.7886 27.4074 75.6469 21.5298 85.2424C0.121279 120.193 45.7556 148.941 75.1376 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.138 26.1623Z",
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M89.6406 126.66C92.9543 126.66 95.6406 123.974 95.6406 120.66C95.6406 117.346 92.9543 114.66 89.6406 114.66C86.3269 114.66 83.6406 117.346 83.6406 120.66C83.6406 123.974 86.3269 126.66 89.6406 126.66Z",
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M40.6406 43.6602C45.0589 43.6602 48.6406 40.0784 48.6406 35.6602C48.6406 31.2419 45.0589 27.6602 40.6406 27.6602C36.2223 27.6602 32.6406 31.2419 32.6406 35.6602C32.6406 40.0784 36.2223 43.6602 40.6406 43.6602Z",
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group",
					children: [
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_4",
							d: "M139.697 19.3355C142.521 22.1933 142.521 26.6965 139.697 29.5543L127.487 41.7823L115.259 29.5543C112.453 26.7311 112.453 22.124 115.259 19.3355C116.61 17.9499 118.411 17.2224 120.316 17.2224C122.221 17.2224 124.092 17.9499 125.374 19.3528L126.309 20.3227C126.621 20.5998 127.002 20.7557 127.417 20.7557C127.833 20.7557 128.231 20.6345 128.526 20.3227L129.496 19.3528C130.847 17.9672 132.648 17.2397 134.553 17.2397C136.458 17.2397 138.329 17.9672 139.68 19.3181L139.697 19.3355Z",
							fill: "url(#paint0_linear_3830_13217)"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_5",
							d: "M154.852 13.897V45.7314C154.852 47.8617 153.086 49.6284 150.955 49.6284H135.731C134.19 49.6284 132.769 50.4424 131.99 51.828C130.795 53.993 128.838 57.7169 127.365 60.6093L122.81 51.9666C122.048 50.5463 120.611 49.6977 119.035 49.6977H103.879C101.749 49.6977 99.9824 47.931 99.9824 45.8006V13.897C99.9824 11.7666 101.749 10 103.879 10H150.99C153.103 10 154.852 11.7666 154.852 13.897ZM141.897 31.7367C145.898 27.7358 145.898 21.2061 141.897 17.2052C139.94 15.2826 137.377 14.2088 134.64 14.2088C131.903 14.2088 129.427 15.248 127.504 17.1012C125.582 15.248 123.07 14.2088 120.368 14.2088C117.666 14.2088 115.016 15.248 113.094 17.2052C109.093 21.2061 109.093 27.7185 113.094 31.7367L126.396 45.0732C126.707 45.3503 127.088 45.5062 127.504 45.5062C127.92 45.5062 128.318 45.3503 128.63 45.0732L141.897 31.7367Z",
							fill: "url(#paint1_linear_3830_13217)"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_6",
							d: "M164.412 75.4525C165.139 77.0633 165.191 78.778 164.568 80.458C163.944 82.0861 162.715 83.3851 161.069 84.1126L124.991 99.718C119.518 102.108 113.387 102.42 107.654 100.653L99.704 98.1765C93.5727 96.2886 86.9737 96.5484 81.0503 98.9039L73.9663 101.71L63.0547 78.2411C84.1679 61.0076 110.962 68.5245 121.614 72.612C123.883 73.4953 125.268 75.8509 124.818 78.3103V78.3796C124.593 79.7652 123.814 80.9257 122.653 81.7051C121.458 82.4845 120.038 82.7789 118.652 82.4672L102.545 78.9512C101.696 78.7953 100.916 79.2976 100.691 80.1463C100.535 80.995 101.038 81.7744 101.886 81.9995L117.994 85.5155C118.566 85.6367 119.189 85.706 119.761 85.706C121.389 85.706 123 85.2037 124.385 84.2511C125.961 83.1773 127.087 81.6704 127.624 79.8865L156.808 71.9365C159.857 71.0532 163.061 72.5601 164.395 75.4872L164.412 75.4525Z",
							fill: "url(#paint2_linear_3830_13217)"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_7",
							d: "M56.1513 75.4956L50.9398 77.9258C49.9602 78.3826 49.5363 79.5471 49.9931 80.5267L64.6693 112C65.1261 112.98 66.2906 113.403 67.2703 112.947L72.4818 110.516C73.4614 110.06 73.8853 108.895 73.4284 107.915L58.7523 76.4423C58.2955 75.4626 57.131 75.0388 56.1513 75.4956Z",
							fill: "url(#paint3_linear_3830_13217)"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "Vector_8",
							d: "M42.0638 76.3199L37.6685 78.3694C36.1947 79.0566 35.5571 80.8085 36.2444 82.2823L53.7167 119.752C54.4039 121.226 56.1558 121.863 57.6296 121.176L62.0249 119.126C63.4987 118.439 64.1363 116.687 63.449 115.214L45.9767 77.744C45.2895 76.2702 43.5376 75.6326 42.0638 76.3199Z",
							fill: "url(#paint4_linear_3830_13217)"
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_3830_13217",
				x1: 127.487,
				y1: 17.2224,
				x2: 127.487,
				y2: 41.7996,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#875F9D" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC3"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_3830_13217",
				x1: 127.417,
				y1: 10,
				x2: 127.417,
				y2: 60.6093,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#292160" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4F429A"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_3830_13217",
				x1: 114.045,
				y1: 67.3814,
				x2: 114.045,
				y2: 101.762,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#875F9D" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC3"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_3830_13217",
				x1: 53.5456,
				y1: 76.7107,
				x2: 69.876,
				y2: 111.731,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6EC8B9" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#90D3CB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_3830_13217",
				x1: 39.8662,
				y1: 77.3446,
				x2: 59.8272,
				y2: 120.151,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6EC8B9" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#90D3CB"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgContactIcon);
export { ForwardRef as ReactComponent };
